import { Trans, useTranslation } from 'next-i18next'

import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import TimesBoldIcon from '~/components/Icons/svgs/TimesBoldIcon'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { Link } from '~/components/Link'
import ROUTES from '~/shared/constants/routes.const'

export default function SuccessPopup(): React.ReactElement {
  const { t } = useTranslation('referral')

  return (
    <div className="fixed w-screen h-screen bg-black bg-opacity-70 flex justify-center items-center top-0 left-0 z-10">
      <div className="bg-white rounded p-3 max-w-75 w-full text-center text-purple">
        <Link className="flex ml-auto w-5" to={ROUTES.DASHBOARD}>
          <SVGIcon className="cursor-pointer hover:scale-110 duration-300" icon={TimesBoldIcon} size={20} />
        </Link>
        <h2 className="text-sm font-bold mb-2 flex items-center justify-center gap-1 my-1">
          {Trans({
            t,
            i18nKey: 'earnedXP',
            components: {
              xp: (
                <ResponsiveImage
                  alt={t('alt_texts.xp')}
                  fit="contain"
                  height={22}
                  imageClassName="flex-1"
                  srcKey="scoreboard/xp.png"
                  width={24}
                />
              ),
            },
            children: t('earnedXP'),
          })}
        </h2>
        <Link
          className="bg-purple text-white rounded px-4 py-2 mt-2 flex justify-center items-center hover:bg-purple-dark hover:scale-105 duration-300"
          to={ROUTES.DASHBOARD}
        >
          {t('cool')}
        </Link>
      </div>
    </div>
  )
}
